<template>
  <div>
    <div class="filter">
      <el-button type="primary" size="mini" @click="createGroup"
        >添加模板组</el-button
      >

      <el-input
        type="number"
        size="mini"
        v-model="groupId"
        placeholder="模板组ID"
      />

      <el-input size="mini" v-model="groupName" placeholder="模板组名称" />

      <el-button size="mini" @click="resetCondition">重置</el-button>
    </div>
    <div class="filter">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          批量操作<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="Delete">批量删除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="list">
      <el-table
        ref="table"
        :data="list"
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="模板组ID"> </el-table-column>
        <el-table-column prop="name" label="模板组名称"> </el-table-column>
        <el-table-column prop="num" label="模板数量"> </el-table-column>
        <el-table-column prop="source" label="适用系统">
          <template slot-scope="scope">
            <span>{{ getSource(scope.row.source) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作" width="220">
          <template slot-scope="scope">
            <span class="action" @click="handleEdit(scope.row.id)"
              >查看模板</span
            >
            <span class="action" @click="handleDelete(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="创建组" :visible.sync="dialogVisible" width="60%">
      <div class="form">
        <el-form ref="form" :model="form">
          <el-form-item label="组名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TemplateList',
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        source: 0
      },
      groupId: '',
      groupName: '',
      selection: []
    };
  },
  watch: {
    groupId() {
      this.queryList();
    },
    groupName() {
      this.queryList();
    }
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    list() {
      return this.$store.state.groupList.list || [];
    },
    total() {
      return this.$store.state.groupList.total;
    },
    limit() {
      return this.$store.state.groupList.pageSize;
    }
  },
  beforeDestroy() {
    this.$store.commit('groupList/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    createGroup() {
      this.dialogVisible = true;
      this.form.name = '';
      this.form.source = 1;
    },
    saveGroup() {
      this.form.source = 1;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$store.dispatch('groupList/create', this.form).then(() => {
            this.dialogVisible = false;
            this.queryList();
          });
        }
      });
    },
    getSource(source) {
      switch (source) {
        case 1:
          return 'FTX';
        case 2:
          return '海神';
        case 0:
          return '通用';
        default:
          return '其他';
      }
    },
    queryList() {
      this.$store.commit('groupList/update', {
        condition: {
          groupName: this.groupName || undefined,
          groupId: this.groupId || undefined
        }
      });
      this.refreshData();
    },
    handleCommand(command) {
      if (command === 'Activate') {
        this.batchActivate(this.selection, 1);
      } else if (command === 'Deactivate') {
        this.batchActivate(this.selection, 0);
      } else {
        this['batch' + command](this.selection);
      }
    },
    resetCondition() {
      this.$store.commit('groupList/update', {
        condition: {}
      });
      this.groupId = '';
      this.groupName = '';
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    fetchData() {
      this.$store.dispatch('groupList/fetch', {});
    },
    handleSizeChange(pageSize) {
      this.$store.commit('groupList/update', {
        page: 1,
        pageSize
      });
      this.fetchData();
    },
    handleChangePage(page) {
      this.$store.commit('groupList/update', {
        page
      });
      this.fetchData();
    },
    handleEdit(id) {
      this.$router.push('/template/private?gid=' + id);
    },
    handleDelete(id) {
      this.batchDelete([id]);
    },
    batchDelete(ids) {
      this.$confirm('是否删除?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$refs.table.clearSelection();
        this.$store
          .dispatch('groupList/delete', {
            ids
          })
          .then(() => {
            this.selection = [];
            this.refreshData();
          });
      });
    },
    handleSelectionChange(selection) {
      this.selection = selection.map(item => item.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  padding: 25px;
}

.action {
  color: #4a90e2;
  cursor: pointer;
  padding: 0 10px;
}

.filter {
  background: #fff;
  padding: 0 32px 16px 32px;
  display: flex;
  align-items: center;
  > * {
    margin-right: 8px;
    max-width: 150px;
  }
}
</style>
